import { createContext, useState, useContext } from "react"

export const MassBalancePageContext   = createContext()
export const useMassBalancePage       = () => useContext(MassBalancePageContext)

export const MassBalancePageProvider  = ({ children }) => {

    
const [isFormOpen,   setFormOpen] = useState(false)
const [selectedTerminal, setSelectedTerminal] = useState(null)
const [selectedDate, setSelectedDate] = useState(null)
const [selectedProducts, setSelectedProducts] = useState([])
const [selectedViewType, setSelectedViewType] = useState('heatmap')
const [selectedHeatmapMode, setSelectedHeatmapMode] = useState('porcentagem')


    const value = {

        isFormOpen,
        setFormOpen,
        selectedTerminal,
        setSelectedTerminal,
        selectedDate,
        setSelectedDate,
        selectedProducts,
        setSelectedProducts,
        selectedViewType,
        setSelectedViewType,
        selectedHeatmapMode,
        setSelectedHeatmapMode

    }
    
    return (
        <MassBalancePageContext.Provider value={value}>
            {children}
        </MassBalancePageContext.Provider>
    )
}

